export type ImageAspectRatio =
  | '1:1'
  | '3:1'
  | '3:2'
  | '3:4'
  | '4:3'
  | '4:5'
  | '8:3'
  | '16:9'
  | '2:1';

interface ImageOptions {
  aspectRatio?: ImageAspectRatio;
  height?: number;
}

export const getContentstackImageURL = (
  originalURL: string,
  width: number,
  options?: ImageOptions,
) => {
  const url = new URL(originalURL);
  url.searchParams.set('width', width.toString());
  url.searchParams.set('auto', 'webp');
  url.searchParams.set('quality', '70');

  if (options?.aspectRatio) {
    url.searchParams.set('crop', options.aspectRatio);
  }
  if (options?.height) {
    url.searchParams.set('height', options.height.toString());
  }

  return url.toString();
};

export const getContentstackImagesForWidths = (
  originalURL: string,
  widths: number[],
  options?: ImageOptions,
) =>
  widths.map((width) => ({
    src: getContentstackImageURL(originalURL, width, options),
    width,
  }));
